import React from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import SignIn from './components/SignIn';
import Progress from './components/Progress';
import Proofread from './components/Proofread';
import Utils from './lib/Utils';

import Auth from './lib/Auth';

class App extends React.Component {
  render () {
    let searches = Utils.getUrlVars();

    return (
      <Router>
        <Switch>
          <Route exact path="/signin" component={SignIn}/>
          <Route path="/proofread" 
            render={(props)=><Proofread searches={searches} {...props}/>} />
          <Auth>
            <Switch>_
              <Route exact path="/" 
                render={(props)=><Progress searches={searches} {...props}/>} />
              <Redirect exact from="/" to="/signin"/>
              <Redirect exact path="/progress" to="/"/>
              <Redirect exact path="/order-confirm" to="/"/>
              <Route render={() => {
                setTimeout(()=>{
                  window.location.href = '/';
                }, 5000);
                return (
                  <div style={{padding:'10px 20px'}}>
                    <h1>Document Not Found.</h1>
                    <p>Redirect to root at after 5 seconds.</p>
                  </div>
                );
              }} />
            </Switch>
          </Auth>
        </Switch>
      </Router>
    );
  }
}

export default App;
